import { render, staticRenderFns } from "./GalleryImageModal.vue?vue&type=template&id=e85aab84"
import script from "./GalleryImageModal.vue?vue&type=script&lang=js"
export * from "./GalleryImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports